















































































































































































































































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import Form, { Send } from '@/components/form-base';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';

import CampaignApi from '@/services/rest/bemob/campaign';

import CurrencyMixin from '@/components/helpers/currency-mixin';
import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';

import { ErrorParseMethodEnum } from '@/services/models/Enums';
import MenuReportDialogsMixin from '@/views/layout/navigation/mixins/menu-report-dialogs-mixin';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import Template from '@/views/reports/forms/traffic_sources/template.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import TagApi from '@/services/rest/bemob/tag';
import CostModel from '@/views/reports/forms/campaign/components/cost-model.vue';
import UiInfo from '@/components/ui/ui-info.vue';
import TrafficSourceAPI from '@/services/rest/bemob/traffic-source';
import DomainsApi from '@/services/rest/bemob/domains';
import OffersApi from '@/services/rest/bemob/offer';

const md5 = require('md5');


@Component({
  components: {
    CostModel,
    Template,
    FormOverlay,
    DialogForm,
    ErrorAggregator,
    NoTagFound,
    UiInfo,
  }
})
export default class BulkEditDialog extends mixins<Form, ReportMixin, MenuReportDialogsMixin, BasicHelperMixin, CurrencyMixin>(
  Form, 
  ReportMixin, 
  MenuReportDialogsMixin,
  BasicHelperMixin,
  CurrencyMixin,
) {
  campaignApi: CampaignApi = new CampaignApi();
  domainsApi: DomainsApi = new DomainsApi();
  trafficSourceSelectOptions:TrafficSource[] = []
  trafficSourceApi: TrafficSourceAPI = new TrafficSourceAPI();
  offersApi: OffersApi = new OffersApi();
  offerOptions: Offer[] = [];
  tagApi: TagApi = new TagApi();
  loading: boolean = false;

  form: any = { ...this.defaultBulkForm };
  checkboxState = { ...this.defaultCheckboxState }

  show: boolean = false;
  errorsControlActive: boolean = false;
  errorMessage: string = '';
  errorsRaw: any = null;
  activeWorkspaceId: string = null;

  get selectedItems() {
    return this.$store.state.table.selectedItems.filter(({ isDirect }) => !isDirect)
  }
  
  get defaultBulkForm() {
    return {
      costModel: 'auto',
      costValue: 0,
      maxCostEnabled: false,
      maxCostUsd: null,
      maxCostAction: 1,
      maxCostBotOfferId: null,
      currencyId: 'USD',
      trafficSource: '',
      trackingDomainId: '',
      trafficLossPercent: 0,
      postbackPercent: 100,
      uniquenessPeriod: 24 * 3600,
      tags: [],
      sendCustomConversionMode: 'all',
      sendCustomConversionIds: [],
      doNotSendNotSpecifiedConversions: false,
      userAgentClientHintsEnabled: 0,
      botFiltersMode: 0,
      conversionNotificationUrl: ''
    }
  }

  get costModelForm() {
    return {
      workspaceId: this.activeWorkspaceId,
      countryId: 0
    }
  }

  get defaultCheckboxState() {
    return {
      trafficSource: false,
      tags: false,
      trackingDomainId: false,
      uniquenessPeriod: false,
      conversionNotificationUrl: false,
      currencyId: false,
      trafficLossPercent: false,
      postbackPercent: false,
      sendCustomConversion: false,
      userAgentClientHintsEnabled: false,
      botFiltersMode: false,
    }
  }

  get FFconversionNotificationUrlEnabled() {
    return this.$FF.conversionNotificationUrl?.enabled
  }

  get postbackPercent() {
    return this.form.postbackPercent
  }

  set postbackPercent(val) {
    this.form.postbackPercent = Number((+val || 0).toFixed(6).toString())
  }

  get trafficLossPercent() {
    return this.form.trafficLossPercent
  }

  set trafficLossPercent(val) {
    this.form.trafficLossPercent = Number((+val || 0).toFixed(6).toString())
  }
  
  get customConversions() {
    const customEvents = Object.values(this.$store.state.table.customEvents) as customEvent[]
    return customEvents.filter((item:customEvent)=>item.sendPostback && item.status==='active')
  }

  toggleElements(key) {
    this.checkboxState = {
      ...this.checkboxState,
      [key]: !this.checkboxState[key],
    }
  }

  get trafficSourceSelectOptionsWithNone() {
    return [{
      name: this.t('None'),
      id: ''
    }, ...this.trafficSourceSelectOptions]
  }

  get fetchTrafficSourcesOptions(){
    if(this.$store.state.cache.trafficSources.isAllInCache){
      return
    }
    return ({ search })=>this.trafficSourceApi.getList({
      search:search,
      status:'active',
      limit:'200',
      columns:['name','id','workspaceId'],
      workspaceId:this.activeWorkspaceId
    })
  }

  get allWorkspaceIds() {
    return [...new Set([this.activeWorkspaceId,...this.$store.getters.allPublicWorkspacesIds])]
  }

  get trackingDomains() {
    return this.$store.getters.cache.trackingDomainsWithAccountDefault.filter((item)=>{
      if(!item.id) return true;
      return this.allWorkspaceIds.some(workspace=>item.workspaceIds.includes(workspace))
    })
  }

  get uniquenessPeriod() {
    return this.form.uniquenessPeriod / 3600;
  }

  set uniquenessPeriod(value: number) {
    this.form.uniquenessPeriod = value * 3600;
  }

  get errors() {
    return this.errorsRaw
      ? this.translateErrors(this.errorsRaw, this.errorMessage)
      : [];
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify({ ...this.form, ...this.checkboxState }));
  }

  async mounted() {
    this.$on('error', (e: any) => {
      this.$store.commit('loading', false);

      this.errorsRaw = this.parseErrors(e.data.errors, ErrorParseMethodEnum.numerate);
      this.errorMessage = e.data.message;
      this.errorsControlActive = true;
    });

    this.$store.commit('loading', true);

    this.activeWorkspaceId = this.selectedItems[0].DT_RowWorkspaceId

    await this.load();

    this.$store.commit('loading', false);
    this.show = true;
    this.oldHash = this.getCurrentHash();

    this.setTrafficSourceOptions()
    this.setOfferOptions()

    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }
    if(!this.$store.state.cache.tags.campaigns.isUploaded){
      await this.tagApi.populateStoreCache({type:'campaigns'})
    }
  }

  async setOfferOptions() {
    if (!this.$store.state.cache.offers.isUploaded) {
      await this.offersApi.populateStoreCache()
    }

    const { uploadedForWorkspace, uploadedForCountryId, isAllInCache, data, isUploaded } = this.$store.state.cache.offers;
    if (isUploaded && isAllInCache) {
      return this.offerOptions = data.filter(item => (
        this.$store.getters.allPublicWorkspacesIds.includes(item.workspaceId)
        || item.workspaceId === this.activeWorkspaceId
      ))
    }

    if (isUploaded && !isAllInCache && uploadedForWorkspace === this.activeWorkspaceId && uploadedForCountryId === 0) {
      return this.offerOptions = [...data]
    }

    if (this.activeWorkspaceId === this.defaultWorkspace.id) {
      return this.offersApi.updateStoreCache({
        workspaceId: this.defaultWorkspace.id,
        countryId: 0
      }).then((res: Offer[]) => {
        this.offerOptions = res
      })
    }

    return this.offersApi.getList({
      status: 'active',
      limit: '200',
      orderBy: 'updated',
      orderDirection: 'desc',
      columns: ['id', 'name', 'countryId', 'affiliateNetworkId', 'affiliateNetworkName', 'countryName', 'url'],
      workspaceId: this.activeWorkspaceId
    }).then((res: Offer[]) => {
      this.offerOptions = res
    })
  }

  async setTrafficSourceOptions(){
    if(!this.$store.state.cache.trafficSources.isUploaded){
      await this.trafficSourceApi.populateStoreCache()
    }
    
    const {uploadedForWorkspace, isAllInCache, data, isUploaded} = this.$store.state.cache.trafficSources;
    if(isUploaded && isAllInCache) {
      return this.trafficSourceSelectOptions = data.filter(item => item.workspaceId === this.activeWorkspaceId)
    }

    if(isUploaded && !isAllInCache && uploadedForWorkspace === this.activeWorkspaceId){
      return this.trafficSourceSelectOptions = data
    }

    if(this.activeWorkspaceId === this.defaultWorkspace.id){
      return this.trafficSourceApi.updateStoreCache({workspaceId:this.defaultWorkspace.id}).then((res:TrafficSource[])=>{
        this.trafficSourceSelectOptions = res
      })
    }

    return this.trafficSourceApi.getList({
      status:'active',
      limit:'200',
      columns:['name','id','workspaceId'],
      workspaceId:this.activeWorkspaceId
    }).then((res:TrafficSource[])=>{
      this.trafficSourceSelectOptions = res
    })
  }
  
  get hasAtLeastOneConversion(){
    const customEvents = Object.values(this.$store.state.table.customEvents) as customEvent[]
    return !!customEvents.filter(item=>item.status === 'active').length
  }
  
  onSendCustomConversionsClick(value){
    if((value==='include'|| value==='exclude') && !this.hasAtLeastOneConversion){
      this.bus.emit('open-dialog', {
        name: 'CustomConversionsSending',
      })
      return true;
    }
  }

  async load() {
    this.form.currencyId = this.currencyListOrderedPreferred[0]?.code
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');
    this.bus.emit('clear-report-selection');
  }

  get dependentKeys() {
    return {
      currencyId: [
        'costValue',
        'costModel',
        'maxCostEnabled',
        'maxCostUsd',
        'maxCostAction',
        'maxCostBotOfferId'
      ]
    }
  }

  get activeElements() {
    const data =  Object.entries(this.checkboxState).reduce((acc, [key, value]) => {
      // collect only enabled but ignore sendCustomConversion
      if (value && key!=='sendCustomConversion' && key!=='trafficSource' ) {
        return {
          ...acc,
          [key]: this.form[key],
          ...this.dependentKeys[key]?.reduce((acc, key) => {
            acc[key] = this.form[key]
            return acc
          }, {})
        }
      }
      return acc
    }, {}) as any
    
    if(this.checkboxState.sendCustomConversion){
      data.sendCustomEventPostback = {
        mode: this.form.sendCustomConversionMode,
        ...(this.form.sendCustomConversionMode !== 'all' ? {ids: this.form.sendCustomConversionIds} : {}),
        doNotSendNotSpecifiedConversions: this.form.doNotSendNotSpecifiedConversions
      }
    }
    
    if(this.checkboxState.trafficSource){
      data.trafficSourceId = this.form.trafficSource.id
    }

    if (this.checkboxState.currencyId) {
      if (!['auto', 'autoCpm'].includes(data.costModel)) {
        delete data.maxCostEnabled;
        delete data.maxCostUsd;
        delete data.maxCostAction;
        delete data.maxCostBotOfferId;
      } else if (!data.maxCostEnabled) {
        data.maxCostEnabled = false;
        delete data.maxCostUsd;
        delete data.maxCostAction;
        delete data.maxCostBotOfferId;
      } else {
        data.maxCostUsd = Number(data.maxCostUsd) || null;
        if (data.maxCostAction !== 0) {
          delete data.maxCostBotOfferId;
        } else {
          data.maxCostBotOfferId = data.maxCostBotOfferId || null;
        }
      }
    }
    
    return data;
  }


  @Send(true)
  submit() {
    const ids = this.selectedItems.map(({ DT_RowId }) => DT_RowId);
    const params = {
      ids,
      data: this.activeElements,
    }

    if(params.data?.tags){
      params.data.tags=params.data?.tags?.map((item)=>item?.id ? item.name : item);
    }

    return this.campaignApi.bulkUpdate(this.activeWorkspaceId, params)
      .then(() => {
        this.trackAnalytics('campaign_bulk_edit',ids.length)
        
        this.close()

        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Changes have been successfully saved'));
      })
  }
  
  trackAnalytics(event,element_count:number){
    const {
      postbackPercent,
      trafficLossPercent,
      uniquenessPeriod,
    } = this.form;

    const {
      trafficSource:trafficSource_enabled,
      postbackPercent:postbackPercent_enabled,
      tags:tags_enabled,
      trafficLossPercent:trafficLossPercent_enabled,
      trackingDomainId:trackingDomainId_enabled,
      uniquenessPeriod:uniquenessPeriod_enabled,
      currencyId:currencyId_enabled,
    } = this.checkboxState;

    this.$mixpanel?.track(event, {
      element_count,
      ...(uniquenessPeriod_enabled && {uniqueness_period:uniquenessPeriod}),
      ...(postbackPercent_enabled && {postbackPercent}),
      ...(trafficLossPercent_enabled && {trafficLossPercent}),
      trafficSource_enabled: trafficSource_enabled,
      tags_enabled: tags_enabled,
      trackingDomain_enabled: trackingDomainId_enabled,
      uniquenessPeriod_enabled: uniquenessPeriod_enabled,
      sendPostBacks_enabled: postbackPercent_enabled,
      trafficLoss_enabled: trafficLossPercent_enabled,
      currency_enabled: currencyId_enabled
    });
  }

  get useClientHintsItems() {
    return [
      {
        value: 0,
        text: this.t('Default (as in Global Settings)')
      },
      {
        value: 1,
        text: this.t('Enabled (For This Campaign)'),
      },
      {
        value: 2,
        text:this.t('Disabled (For This Campaign)')
      }
    ]
  }

  get botFiltersModeItems() {
    return [
      {
        value: 0,
        text: this.t('Default (as in Global Settings)')
      },
      {
        value: 1,
        text: this.t('Enabled (For This Campaign)'),
      },
      {
        value: 2,
        text:this.t('Disabled (For This Campaign)')
      }
    ]
  }
}
